import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
} from 'recharts';
import moment from 'moment';

class ScoreOverTime extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      stroke: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.shape({
        identifier: PropTypes.string,
        value: PropTypes.number,
        xLabel: PropTypes.string,
      })),
    })).isRequired,
  }

  renderCustomLabel = (value, name, props) => {
    const { identifier } = props.payload;
    const percentageValue = (value / 10) * 100;
    if (identifier === 'total_health_index') {
      return value;
    }
    return `${percentageValue}%`;
  }

  render() {
    const { data } = this.props;
    const hasData = _.some(data, item => !_.isEmpty(item.data));
    const yDomain = hasData ? undefined : [0, 10];

    return (
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={hasData ? data : [{ xLabel: moment().utc().format('YYYY-MM-DD') }]}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="xLabel"
            type="category"
            allowDuplicatedCategory={false}
          >
            {!hasData && <Label value="No data" offset={180} position="top" />}
          </XAxis>
          <YAxis
            type="number"
            dataKey="value"
            width={24}
            domain={yDomain}
          />
          <Tooltip formatter={this.renderCustomLabel} />
          <Legend />
          {data.map(score => (
            <Line
              dataKey="value"
              data={score.data}
              name={score.name}
              key={score.name}
              stroke={score.stroke}
              connectNulls
              isAnimationActive={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    );
  }
}

export default ScoreOverTime;
